export default __webpack_public_path__ + "static/600-a24b887fca0eac7d93c2f6abfb408352.gif";